export function fetchKeyDeals (props){
	return {
		type : 'FETCH_KEY_DEALS',
		props
	}
}

export function fetchApiData (response){
	return {
		type : 'FETCH_API_DATA',
		response
	}
}

export function selectRegion (selectedRegion){
	return {
		type : 'SELECT_REGION',
		selectedRegion
	}
}

export function closeRegion (closedRegion){
	return {
		type : 'CLOSE_REGION',
		closedRegion
	}
}
export function selectLocation (selectedLocation , selectedLocationIndex ){
	return {
		type : 'SELECT_LOCATION',
		selectedLocation,
		selectedLocationIndex
	}
}

export function closeLocation (closedLocation){
	return {
		type : 'CLOSE_LOCATION',
		closedLocation
	}
}

export function validateUser (password){
	return {
		type : 'VALIDATE_USER',
		password
	}
}


// WEBPACK FOOTER //
// ./src/js/actions/actionCreators.js